import { all, takeEvery, put, call } from "redux-saga/effects";
// import { notification } from 'antd'
import { history } from "../../index";
import { login, currentAccount, logout } from "../../services/users";
import actions from "./actions";
import store from "store";

export function* LOGIN({ payload }) {
  const { contact, password } = payload;
  yield put({
    type: "user/SET_STATE",
    payload: {
      loading: true,
    },
  });
  const success = yield call(login, contact, password);
  yield put({
    type: "user/LOAD_CURRENT_ACCOUNT",
  });
  if (success) {
    // toast("Logged in Successfully", { type: "success", autoClose: 2000 });
    // history.push("/");
    yield put({
      type: "user/SET_STATE",
      payload: {
        wrong: false,
      },
    });
  } else {
    yield put({
      type: "user/SET_STATE",
      payload: {
        wrong: true,
      },
    });
  }
}

export function* LOAD_CURRENT_ACCOUNT() {
  yield put({
    type: "user/SET_STATE",
    payload: {
      loading: true,
    },
  });
  var user = store.get("user");
  var session = store.get("session");
  if (user !== undefined) {
    if (user.roles.id === 9) {
      const response = yield call(currentAccount, 9);
      if (response) {
        const { studentData, student_class, student_section, student_info } =
          response;
        store.set("studentData", studentData);
        store.set("student_class", student_class);
        store.set("student_section", student_section);
        store.set("student_info", student_info);
        store.set("role", user.roles);
        var user = store.get("user");

        if (user !== undefined)
          yield put({
            type: "user/SET_STATE",
            payload: {
              id: user.id,
              user: user,
              contact: user.sms_number,
              name: user.first_name,
              is_active: user.is_active,
              studentData: studentData,
              student_class: student_class,
              student_section: student_section,
              student_info: student_info,
              session: session,
              role: user.roles,
            },
          });
        history.push("/home");
      }
    } else {
      const response = yield call(currentAccount, 3);
      if (response) {
        const { staffData } = response;
        store.set("staffData", staffData);
        store.set("role", user.roles);
        var user = store.get("user");
        if (user !== undefined)
          yield put({
            type: "user/SET_STATE",
            payload: {
              id: user.id,
              user: user,
              contact: user.sms_number,
              name: user.first_name,
              is_active: user.is_active,
              staffData: staffData,
              session: session,
              role: user.roles,
            },
          });
        history.push("/teacherHomeV2");
      }
    }
  }
  yield put({
    type: "user/SET_STATE",
    payload: {
      loading: false,
    },
  });
}
export function* LOAD_CURRENT_ACCOUNT1() {
  const user = store.get("user");
  const role = store.get("role");
  if (role !== undefined)
    if (role.id === 9) {
      const studentData = store.get("studentData");
      const student_class = store.get("student_class");
      const student_section = store.get("student_section");
      const student_info = store.get("student_info");
      const session = store.get("session");
      if (user !== undefined)
        yield put({
          type: "user/SET_STATE",
          payload: {
            id: user.id,
            user: user,
            contact: user.sms_number,
            name: user.first_name,
            is_active: user.is_active,
            studentData: studentData,
            student_class: student_class,
            student_section: student_section,
            student_info: student_info,
            role: role,
            session: session,
          },
        });
    } else {
      const staffData = store.get("staffData");
      const session = store.get("session");
      if (user !== undefined)
        yield put({
          type: "user/SET_STATE",
          payload: {
            id: user.id,
            user: user,
            contact: user.sms_number,
            name: user.first_name,
            is_active: user.is_active,
            staffData: staffData,
            session: session,
            role: role,
          },
        });
    }
}

export function* LOGOUT() {
  yield call(logout);
  //   toast("Logged out Successfully", { type: "success", autoClose: 2000 });
  yield put({
    type: "user/SET_STATE",
    payload: {
      id: "",
      name: "",
      role: {},
      contact: "",
      email: "",
      avatar: "",
      authorized: false,
      loading: false,
      user: {},
      student_info: {},
      studentData: {},
      student_class: {},
      student_section: {},
      staffData: {},
      session: {},
    },
  });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOGIN, LOGIN),
    takeEvery(actions.LOAD_CURRENT_ACCOUNT, LOAD_CURRENT_ACCOUNT),
    takeEvery(actions.LOGOUT, LOGOUT),
    LOAD_CURRENT_ACCOUNT1(), // run once on app load to check user auth
  ]);
}
